import { Box, Toolbar, Typography } from '@mui/material'
import { useContext } from 'react'

import { GeotokenIdentification } from '../../../Components'
import { MinterAuctionContext } from '../../../Contexts'
import EventTypeFilter from './EventTypeFilter'

const EventsHeader: React.FC = () => {
  const { quadkey } = useContext(MinterAuctionContext)

  return (
    <Toolbar>
      <Box display="flex" flexGrow={1}>
        <Box alignItems="center" display="flex" marginX={1} style={{ zoom: 0.75 }}>
          <EventTypeFilter />
        </Box>
        <Box alignItems="center" display="flex">
          <Typography variant="button" color="textPrimary">
            {'events for'}
          </Typography>
        </Box>
        <Box alignItems="center" display="flex" marginX={1}>
          <GeotokenIdentification quadkey={quadkey} worldMap={false} />
        </Box>
      </Box>
    </Toolbar>
  )
}

export default EventsHeader
